export const QuestionOptions = ({ answerOptions }) => {
  return (
    <div className="row mt-4">
      <div className="col-md-6">
        <ul class="list-group list-group-flush">
          {answerOptions?.map((answerOption, index) => (
            <li class="list-group-item" key={index}>
              {answerOption?.left ? answerOption?.left : "----------"}
            </li>
          ))}
        </ul>
      </div>
      <div className="col-md-6">
        <ul class="list-group list-group-flush">
          {answerOptions?.map((answerOption, index) => (
            <li class="list-group-item" key={index}>
              {answerOption?.right ? answerOption?.right : "----------"}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
